import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../auth/PasswordPrompt/PasswordPrompt.css";
import {
  ADMIN_PASSWORD,
  grantAdminAccess,
  hasPremiumEditorAccess,
} from "../../utils/adminAccess";

const AdminAccess = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [feedback, setFeedback] = useState({ type: "", text: "" });

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!hasPremiumEditorAccess()) {
      setFeedback({
        type: "error",
        text: "Necesitas activar primero el modo premium desde Acceso privado para poder entrar al panel.",
      });
      return;
    }

    if (password !== ADMIN_PASSWORD) {
      setFeedback({
        type: "error",
        text: "La clave de administrador no es correcta.",
      });
      return;
    }

    grantAdminAccess();
    navigate("/admin", { replace: true });
  };

  return (
    <div className="password-page">
      <div className="password-ambient" />
      <div className="password-card">
        <p className="password-kicker">Administracion</p>
        <h1>Acceso al panel interno</h1>
        <p className="password-copy">
          Esta entrada es solo para gestionar premios, nominados y mantenimiento de votos desde la
          propia web. El panel mantiene la clave de admin, pero ahora exige tambien tener activo el
          modo premium.
        </p>

        <form className="password-form" onSubmit={handleSubmit}>
          <label className="password-field">
            <span>Clave de administrador</span>
            <input
              className="inputPass"
              type="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                if (feedback.text) {
                  setFeedback({ type: "", text: "" });
                }
              }}
              placeholder="Introduce la clave de admin"
              required
            />
          </label>

          {feedback.text ? (
            <p className={`password-feedback ${feedback.type}`} aria-live="polite">
              {feedback.text}
            </p>
          ) : null}

          <div className="password-actions">
            <button
              className="secondary-access-button"
              type="button"
              onClick={() => navigate("/password-prompt")}
            >
              Volver al acceso privado
            </button>
            <button className="accesButton" type="submit">
              Entrar al panel
            </button>
          </div>
        </form>

        <p className="password-note">
          Acceso requerido: modo premium activo + clave de administrador.
        </p>
      </div>
    </div>
  );
};

export default AdminAccess;
